import { setComplaintId, setCanUserSeeFeedbackForm } from './feedback_complaint';
import { addComplaintRequest, IAddComplaintOptions } from '../../api/complaint';
import { IThunkActionCreator } from '../index';

export type TAddComplaintActions = IAddComplaintRequested | IAddComplaintRequestFinished | IAddComplaintRequestFailed;

interface IAddComplaintRequested {
  type: 'IAddComplaintRequested';
}

interface IAddComplaintRequestFinished {
  type: 'IAddComplaintRequestFinished';
  getUserFeedback: boolean;
}

interface IAddComplaintRequestFailed {
  errorMessage: string;
  type: 'IAddComplaintRequestFailed';
}

export function addComplaint(options: IAddComplaintOptions): IThunkActionCreator<Promise<void>> {
  // @ts-ignore
  return async (dispatch, getState, context) => {
    dispatch<IAddComplaintRequested>({
      type: 'IAddComplaintRequested',
    });

    /* istanbul ignore next */
    const moderationComplaintsBrowserUrl = context.config.get('moderationComplaints.browserUrl') as string;
    if (!moderationComplaintsBrowserUrl) {
      throw new Error(`'moderationComplaints.browserUrl' is not configured`);
    }

    try {
      const response = await addComplaintRequest(context.custom.makeRequest, moderationComplaintsBrowserUrl, options);

      if (response.complaintId) {
        dispatch(setComplaintId(Number(response.complaintId)));
      }

      dispatch<IAddComplaintRequestFinished>(setCanUserSeeFeedbackForm(response.getUserFeedback));

      return response;
    } catch (error) {
      dispatch<IAddComplaintRequestFailed>({
        errorMessage: 'Не смогли отправить вашу жалобу. Попробуйте повторить позже.',
        type: 'IAddComplaintRequestFailed',
      });
      throw new Error(error);
    }
  };
}
